// extracted by mini-css-extract-plugin
export default {"item":"menu-item-item--02697","link":"menu-item-link--b7c5a","menu-link--with-children":"menu-item-menu-link--with-children--b1f06","shopAll":"menu-item-shopAll--57cb2"};